import Component from "./OperationalDays";
export default Component;
